import React from 'react';
import { Platform } from 'react-native';
import queryString from 'query-string';
import FooterLayout from './FooterLayout';
import { processStyles } from '../util.style';
import FooterConfig from './config';
import {
  getComponentScreenDimensions,
  getScreenTypeFromId,
} from '../../../utils/responsive';
import { parseDimension } from '../util.style';
import { getActions } from '../../shared';

interface FooterProps {
  attributes?: any;
  style?: any;
  libraryComponentManifest?: any;
  onMenuItemPress?: (item: MenuItem) => void;
  onLegalLinkPress?: (link: LegalLink) => void;
  onPress?: (actions: any, options?: any) => void;
  actions?: any;

  id?: string;
  width?: number;
  height?: number;
  [key: string]: any;
}

interface MenuItem {
  id: string;
  text: string;
  href?: string;
  action?: any; // Action configuration for menu items
}

interface LegalLink {
  text: string;
  href: string;
}

export default function Footer(props: FooterProps) {
  const isCanvas =
    Platform.OS === 'web' &&
    !queryString.parse(window?.location?.search)?.target;

  const handleMenuItemPress = (item: MenuItem) => {
    if (isCanvas) return;
    if (item.action && props.onPress) {
      const actionProps = {
        ...props,
        attributes: {
          ...props.attributes,
          action: item.action,
        },
      };
      const actionData = getActions(actionProps, 'action');
      props.onPress(actionData, {});
    } else if (props.onMenuItemPress) {
      props.onMenuItemPress(item);
    }
  };
  if (isCanvas) {
    const {
      attributes,
      style,
      libraryComponentManifest,
      id,
      width,
      height,
      ...otherProps
    } = props;

    const screenType = getScreenTypeFromId(id);
    const breakpointIndex = id?.endsWith('.0') ? 0 : id?.endsWith('.1') ? 1 : 2;
    const screenDimensions = getComponentScreenDimensions(
      FooterConfig,
      breakpointIndex
    );

    const { finalStyle } = processStyles({
      attributes,
      style,
      config: FooterConfig,
      libraryComponentManifest,
      id,
      ...otherProps,
    });

    const effectiveWidth = width || screenDimensions.width;
    const effectiveHeight =
      height || finalStyle.height || screenDimensions.height;

    const containerStyle = {
      backgroundColor: finalStyle.backgroundColor || '#1A2737',
      color: finalStyle.color || '#ffffff',
      height: parseDimension(effectiveHeight),
      paddingHorizontal: finalStyle.paddingHorizontal || 16,
      width: parseDimension(effectiveWidth),
    };

    // Mock data for canvas mode
    const mockMenuList = {
      items: [
        { id: 'item1', text: 'About Us', href: '#about' },
        { id: 'item2', text: 'Services', href: '#services' },
        { id: 'item3', text: 'Contact', href: '#contact' },
        { id: 'item4', text: 'Support', href: '#support' },
        { id: 'item5', text: 'Privacy Policy', href: '#privacy' },
        { id: 'item6', text: 'Terms of Service', href: '#terms' },
      ],
    };

    const mockLogo = {
      logoText: 'LOGO',
      imageLogo: [],
    };

    const mockBottomContent = {
      copyrightText: '© Company Inc. 2025',
    };

    const mockLegalLinks = {
      links: [
        { text: '運営会社', href: '#company' },
        { text: 'プライバシーポリシー', href: '#privacy' },
      ],
    };

    // Handle menuList structure
    const menuListData = attributes?.menuList || mockMenuList;
    return (
      <FooterLayout
        attributes={{
          ...attributes,
          menuList: menuListData,
          logo: attributes?.logo || mockLogo,
          bottomContent: attributes?.bottomContent || mockBottomContent,
          legalLinks: attributes?.legalLinks || mockLegalLinks,
        }}
        containerStyle={containerStyle}
        screenType={screenType}
        screenSize={{ width: effectiveWidth, height: effectiveHeight }}
        width={effectiveWidth}
        height={effectiveHeight}
        isCanvasMode={true}
        onMenuItemPress={handleMenuItemPress}
        // attributes={attributes}
        {...otherProps}
        {...props}
      />
    );
  }

  const { finalStyle } = processStyles({
    attributes: props.attributes,
    style: props.style,
    config: FooterConfig,
    libraryComponentManifest: props.libraryComponentManifest,
    ...props,
  });

  const containerStyle = {
    backgroundColor: finalStyle.backgroundColor || '#1A2737',
    color: finalStyle.color || '#ffffff',
    height: finalStyle.height || 300,
    paddingHorizontal: finalStyle.paddingHorizontal || 16,
    ...(finalStyle.width && { width: parseDimension(finalStyle.width) }),
  };

  return (
    <FooterLayout
      {...props}
      containerStyle={containerStyle}
      fontFamily={finalStyle.fontFamily}
      isCanvasMode={false}
      onMenuItemPress={handleMenuItemPress}
    />
  );
}
